import { IActionWithPayload, getRequestActionName } from "store/helper";

export interface IRequestsState {
  [key: string]: {
    isFetching: boolean;
    error?: string;
  };
}

const initialState = {};

export interface IWithIdOrError {
  id?: string;
  additionalRequestId?: string;
  error?: string;
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const requestsReducer = (state: IRequestsState = initialState, action: IActionWithPayload<string, IWithIdOrError>) => {
  const { type } = action;
  const matches = /(.*)_(REQUEST|SUCCESS|FAILURE)/.exec(type);

  if (!matches) {
    return state;
  }

  const [, requestName, requestState] = matches;

  const requestActionName = action.payload ? getRequestActionName(requestName, action.payload) : requestName;

  return {
    ...state,
    [requestActionName]: {
      isFetching: requestState === "REQUEST",
      error: requestState === "FAILURE" ? action.payload && action.payload.error : undefined,
    },
  };
};

export default requestsReducer;
